
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Bike } from '@/services/types';

interface SpeedLimitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedBikes: Bike[];
  onConfirm: (speedLimit: number) => void;
}

export const SpeedLimitDialog: React.FC<SpeedLimitDialogProps> = ({
  open,
  onOpenChange,
  selectedBikes,
  onConfirm
}) => {
  const [speedLimit, setSpeedLimit] = useState<string>('15');
  const [error, setError] = useState<string>('');

  const handleConfirm = () => {
    const limit = parseInt(speedLimit);
    
    if (isNaN(limit) || limit <= 0) {
      setError('Введите корректное значение скорости');
      return;
    }
    
    if (limit > 50) {
      setError('Максимальное ограничение скорости: 50 км/ч');
      return;
    }

    setError('');
    onConfirm(limit);
    onOpenChange(false);
    setSpeedLimit('15');
  };

  const handleCancel = () => {
    setError('');
    setSpeedLimit('15');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Установить ограничение скорости</DialogTitle>
          <DialogDescription>
            Установите ограничение скорости для {selectedBikes.length} выбранных велосипедов.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="speed-limit" className="text-right">
              Скорость
            </Label>
            <div className="col-span-3">
              <Input
                id="speed-limit"
                type="number"
                value={speedLimit}
                onChange={(e) => setSpeedLimit(e.target.value)}
                placeholder="Введите скорость в км/ч"
                min="1"
                max="50"
              />
              {error && (
                <p className="text-sm text-red-500 mt-1">{error}</p>
              )}
            </div>
          </div>
          <div className="text-sm text-muted-foreground">
            Рекомендуемое ограничение: 15-25 км/ч
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            Отмена
          </Button>
          <Button onClick={handleConfirm}>
            Установить ограничение
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
